import cssVariables from "../../themes/cssVariables";

export const configOnOff = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "Temps de ON et de OFF (sur les 6 derniers mois)",
      font: { size: 14 },
      padding: 20,
    },
    legend: {
      position: "bottom",
      labels: { font: { size: 14 } },
    },
    datalabels: {
      display: false,
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
      beginAtZero: true,
      suggestedMax: 100,
    },
  },
};

export const dataConfigOnOff = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "Temps de ON (en %)",
      data: data.on,
      backgroundColor: cssVariables["--light"],
    },
    {
      label: "Temps de OFF (en %)",
      data: data.off,
      backgroundColor: cssVariables["--primary"],
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },

      borderSkipped: false,
    },
  ],
});
